import { defineNuxtPlugin, useHead } from "#app";

import { getEnv } from "@solvari/utils";

export default defineNuxtPlugin(() => {
  useHead({
    script: [
      {
        textContent: `
          window.dataLayer = window.dataLayer ?? [];
          window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        `,
        tagPriority: 200,
      },
    ],
  });

  if (getEnv().config.envType === "local") {
    return;
  }

  useHead({
    script: [
      {
        src: `https://t.${getEnv().network.client.base.split(".").slice(-2).join(".")}/gtm.js?id=GTM-NGVPLSN`,
        defer: true,
        fetchpriority: "low",
        tagPriority: 200,
      },
    ],
  });
});
